import { NgModule } from '@angular/core';
import { PComponent, H1Component } from './components';

@NgModule({
  providers: [
    
  ],
  declarations: [
    PComponent, H1Component
  ],
  exports: [ 
    PComponent, H1Component
  ]
})
export class MicroComponentModule {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/micro-component.module.ts